import { createContext, useContext, useEffect, useReducer, useState } from "react";

import axios, { axiosClient } from "../../api/axios";
import { STATUS_NOT_LOADED } from "../../api/constant";
import { showTypeErrorFetch } from "../../utilities/alerts.utilities"
import { INITIAL_STATE, outIndexReducer, types } from "../../reducers/inventory/outIndexReducer";


export const OutIndexContext = createContext({});

export const OutIndexProvider = ({ children }) => {
  const [state, dispatch] = useReducer(outIndexReducer, INITIAL_STATE);

    useEffect(() => {
        if (state.status == STATUS_NOT_LOADED) {
          axios()
          .get(`inventory/getOutsHeader`,{ 
          params: state.filter,
        })
          .then(({ data }) => {
                dispatch({
                  type: types.MOVEMENTS_LOADED,
                  payload: { elements: data.outs, rows: data.rows },
                });
          })
          .catch((e) => {
            showTypeErrorFetch(e);
          });
        }
        
      }, [state.status]);

    return (
        <OutIndexContext.Provider 
        value={[
          state,
          dispatch,
          {
            
          },
        ]}
          >
          {children}
        </OutIndexContext.Provider>
      );
}

const useOut = () => useContext(OutIndexContext)[0];
const useDispatchOutIndex = () => useContext(OutIndexContext)[1];
const useActionsOutIndex = () => useContext(OutIndexContext)[2];

export {
  useOut,
  useDispatchOutIndex,
  useActionsOutIndex,
};




